"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MapViewStore = void 0;
var AppStorage_1 = require("../../storage/AppStorage");
var MapViewSettings_1 = require("./MapViewSettings");
//stores JSON serialised MapInfo object, used to maintain map state across sessions
var MapViewStore = /** @class */ (function () {
    function MapViewStore(storeKey, mapSettingsProvider) {
        if (mapSettingsProvider === void 0) { mapSettingsProvider = null; }
        var _this = this;
        this.storeKey = storeKey;
        this.mapSettingsProvider = mapSettingsProvider;
        this.initialised = false;
        this.mergeSettingFromProvider = function () {
            if (_this.mapSettingsProvider != null) {
                var providerSettings = _this.mapSettingsProvider.getSettings();
                if (providerSettings !== null) {
                    //merge the setting
                    var currentSettings = _this.getMapInfo();
                    console.log("MapViewStore current: ".concat(JSON.stringify(currentSettings)));
                    //merge overlays first
                    var overlays = new Map(__spreadArray(__spreadArray([], Array.from(currentSettings.overlays.entries()), true), Array.from(providerSettings.overlays.entries()), true));
                    currentSettings.overlays = overlays;
                    //now delete to stop it getting overwritten
                    delete providerSettings.overlays;
                    var baselayers = new Map(__spreadArray(__spreadArray([], Array.from(currentSettings.baselayers.entries()), true), Array.from(providerSettings.baselayers.entries()), true));
                    currentSettings.baselayers = baselayers;
                    //now delete to stop it getting overwritten
                    delete providerSettings.baselayers;
                    _this.saveMapStorage(__assign(__assign({}, currentSettings), providerSettings));
                    console.log("MapViewStore merged: ".concat(JSON.stringify(_this.getMapInfo())));
                }
            }
        };
        this.initMap = function (map, enableBoundsTracking) {
            if (!_this.initialised) {
                if (enableBoundsTracking) {
                    var onMapMoveEnd_1 = function (e) {
                        var map = e.map;
                        var contreCoord = map.getView().getCenter();
                        var m = _this.getMapInfo();
                        m.centre = [contreCoord[0], contreCoord[1]];
                        m.zoom = map.getView().getZoom();
                        _this.saveMapStorage(m);
                    };
                    //remember map extent           
                    map.on('moveend', function (e) {
                        onMapMoveEnd_1(e);
                    });
                }
                _this.initialised = true;
            }
        };
        this.saveMapStorage = function (mapInfo) {
            _this.storage.setValue(_this.storeKey, JSON.stringify(mapInfo, _this.replacer));
        };
        this.isLayerVisibile = function (name, defaultValue) {
            var m = _this.getMapInfo();
            if (!m.overlays.has(name)) {
                m.overlays.set(name, defaultValue);
                _this.saveMapStorage(m);
            }
            return m.overlays.get(name);
        };
        this.onLayerVisibiltyChanged = function (name, visible) {
            var m = _this.getMapInfo();
            m.overlays.set(name, visible);
            _this.saveMapStorage(m);
        };
        this.onAccordionVisibiltyChanged = function (name, visible) {
            var m = _this.getMapInfo();
            if (!m.accordions) {
                m.accordions = {};
            }
            m.accordions[name] = visible;
            _this.saveMapStorage(m);
        };
        this.onBaseLayerChanged = function (name, visible) {
            var m = _this.getMapInfo();
            m.baselayers.set(name, visible);
            _this.saveMapStorage(m);
        };
        this.onOpacityChanged = function (opacity) {
            var m = _this.getMapInfo();
            m.opacity = opacity;
            _this.saveMapStorage(m);
        };
        this.onActivePanelChanged = function (name) {
            var m = _this.getMapInfo();
            m.activePanel = name;
            _this.saveMapStorage(m);
        };
        this.onBaseLayerSliderMoved = function (position) {
            var m = _this.getMapInfo();
            m.baseLayerSliderPosition = position;
            _this.saveMapStorage(m);
        };
        this.clear = function () {
            _this.storage.clear(_this.storeKey);
        };
        this.clearBaselayers = function () {
            var m = _this.getMapInfo();
            m.baselayers = new Map();
            _this.saveMapStorage(m);
        };
        this.storage = new AppStorage_1.AppStorage();
        this.mergeSettingFromProvider();
    }
    MapViewStore.prototype.replacer = function (key, value) {
        if (value instanceof Map) {
            return {
                dataType: 'Map',
                value: Array.from(value.entries()), // or with spread: value: [...value]
            };
        }
        else {
            return value;
        }
    };
    MapViewStore.prototype.reviver = function (key, value) {
        if (typeof value === 'object' && value !== null) {
            //if (value.dataType === 'Map') {
            if (key === 'baselayers' || key === 'overlays') {
                return new Map(value.value);
            }
        }
        return value;
    };
    MapViewStore.prototype.getMapInfo = function () {
        var m = this.storage.getValueFromJson(this.storeKey, this.reviver) || new MapViewSettings_1.MapViewSettings();
        if (!m.baselayers) {
            m.baselayers = new Map();
        }
        return m;
    };
    return MapViewStore;
}());
exports.MapViewStore = MapViewStore;
//# sourceMappingURL=MapViewStore.js.map